/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import { useI18n } from '../utils/i18n';

const Motives = ({
  question,
  strings,
  settings,
  value: answer,
  showErrors,
  errors,
}) => {
  const [index, setIndex] = useState(-1);
  const t = useI18n();
  const [placeholderInput, setPlaceHolderInput] = useState(t('write-here'));
  const [showInput, setShowInput] = useState(false);

  const maxMotivos = get(settings, 'maxMotives', 1);

  const leyend = get(settings, 'leyendMotives')
    ? settings.leyendMotives
    : `[${t('select')} ${
        settings.minMotivos ? `${t('from')} ${settings.minMotivos}` : ''
      } ${settings.maxMotivos ? `${t('to')} ${settings.maxMotivos}` : ''} ${t(
        'items'
      )}]`;
  useEffect(() => {
    // Para mostrar el input
    const selectedMotives = get(answer, 'motives', []);
    let find = false;
    selectedMotives.forEach((motiveResponse, index) => {
      const motive = get(question,'motives',[]).find((motive)=> motiveResponse.id === motive.id);
      if(find) return;
      if (get(motive, 'metadata.settings.showInput', false)) {
        find = true;
        setShowInput(true);
        setIndex(index);
      } else {
        setShowInput(false);
      }
      if (get(motive, 'metadata.settings.placeholder', false)) {
        setPlaceHolderInput(
          get(motive, 'metadata.settings.placeholder', t('write-here'))
        );
      }
    });

    if (selectedMotives.length === 0) setShowInput(false);
  }, [get(answer,'motives'), question, t]);

  function seleccionarMotivo(motivoId) {
    if(answer.disabled) return;
    let motives = [...get(answer, 'motives', [])];
    if (motives.find((motivo) => motivo.id === motivoId)) {
      motives = motives.filter(
        (filter) => filter.id !== motivoId
      );
    } else {
      motives.push({ id: motivoId, comment: null });
    }
    const maxMotivos = settings.maxMotivos;
    motives = motives.slice(-maxMotivos);
    answer.setMotives(motives, {
      preventDirty: showInput
    });
  }

  const motivesLayout = settings.motivesLayout;
  return (
    <div>
      {/* TITULO DE MOTIVES */}
      {question.score_type != null && get(question, 'motives', []).length > 1 && (
        <div style={{ fontSize: '18px', margin: '0px' }} className={'pregunta'}>
          <div
            style={{ maxWidth: '410px', margin: '0px' }}
            className={'preguntaComentario'}
          >
            {t(strings.motivosTitle)}
          </div>
        </div>
      )}
      {/* CANTIDAD MAXIMA DE MOTIVOS */}
      {(settings.maxMotivos > 1 || settings.minMotivos) && (
        <div className={'motives-max-quantity'}>{leyend}</div>
      )}

      <div className={`tabla ${motivesLayout}`}>
        {get(question, 'motives', []).length >= 2 &&
          motivesLayout === 'default' && (
            <div className={'motivos'}>
              {question.motives.map((motivo, j) => (
                <button
                  key={`${question.id}motive${motivo.id}`}
                  data-testid={`${question.id}motive${motivo.id}`}
                  style={{ margin: '5px' }}
                  className={
                    answer &&
                    get(answer, 'motives').find(
                      (motivoSelect) => motivoSelect.id === motivo.id
                    )
                      ? 'motivo selected'
                      : 'motivo'
                  }
                  onClick={() => seleccionarMotivo(motivo.id)}
                >
                  {motivo.ui_name || motivo.name}
                </button>
              ))}
            </div>
          )}

        {get(question, 'motives', []).length >= 2 &&
          motivesLayout !== 'default' && (
            <div className={'motivos-' + motivesLayout}>
              {question.motives.map((motivo, j) => (
                <div
                  key={`${question.id}motive${motivo.id}`}
                  data-testid={`${question.id}motive${motivo.id}`}
                  className={
                    answer &&
                    get(answer, 'motives', []).find(
                      (motivoSelect) => motivoSelect.id === motivo.id
                    )
                      ? `motivo-${motivesLayout} selected`
                      : `motivo-${motivesLayout}`
                  }
                  onClick={() => seleccionarMotivo(motivo.id)}
                >
                  <div className={'not-show'}>
                    {maxMotivos > 1 &&
                      answer &&
                      get(answer, 'motives', []).find(
                        (motivoSelect) => motivoSelect.id === motivo.id
                      ) && <i className={'smile21-square-checked'} />}
                    {maxMotivos > 1 &&
                      answer &&
                      !get(answer, 'motives', []).find(
                        (motivoSelect) => motivoSelect.id === motivo.id
                      ) && <i className={'smile21-square-unchecked'} />}
                    {maxMotivos === 1 &&
                      answer &&
                      get(answer, 'motives', []).find(
                        (motivoSelect) => motivoSelect.id === motivo.id
                      ) && <i className={'smile21-radio-checked'} />}
                    {maxMotivos === 1 &&
                      answer &&
                      !get(answer, 'motives', []).find(
                        (motivoSelect) => motivoSelect.id === motivo.id
                      ) && <i className={'smile21-radio-unchecked'} />}
                  </div>
                  {motivesLayout === 'image' &&<div style={{ display: 'grid' }}>
                    <div className={'image-container'}>
                        <img
                          style={{ marginBottom: '10px',maxWidth: '100%',maxHeight: '100%', }}
                          src={get(motivo, 'metadata.settings.image.src')}
                        />
                    </div>
                  </div>}
                  <span style={{whiteSpace: 'pre-wrap'}}>{motivo.ui_name || motivo.name}</span>
                </div>
              ))}
            </div>
          )}
        {showInput && (
          <div>
            <input
              placeholder={t(placeholderInput)}
              className={`inputMotive ${motivesLayout}`}
              data-testid={`${question.id}motiveInput`}
              value={
                get(get(answer, `motives.${index}`), 'comment') || ''
              }
              onChange={(ev) => {
                if (answer.disabled) return;
                const motives = get(answer, 'motives', []);
                answer.updateMotive({
                  ...motives[index],
                  comment: ev.target.value,
                });
              }}
            />
          </div>
        )}
        {settings.commentEnabled && (
          <div>
            <div className={'pregunta caja'}>
              {settings.commentLayout === 'mini' ? (
                <input
                  disabled={answer.disabled}
                  style={{ height: 'unset' }}
                  value={get(answer, 'comment') || ''}
                  onChange={(ev) => answer.setComment(ev.target.value)}
                  className={'input'}
                  data-testid={`short-comment${question.id}`}
                />
              ) : (
                <textarea
                  disabled={answer.disabled}
                  data-testid={`comment${question.id}`}
                  value={get(answer, 'comment') || ''}
                  onChange={(ev) => answer.setComment(ev.target.value)}
                  className={'input'}
                />
              )}
            </div>
            {showErrors && get(errors, 'comment', []).length > 0 && (
              <p className={'error'}>* {t('errors.complete-comment')}</p>
            )}
          </div>
        )}
      </div>
      {get(question, 'motives', []).length >= 2 && strings.footerMotives && (
        <div style={{ fontSize: '18px' }} className={'pregunta'}>
          <p style={{ maxWidth: '439px' }} className={'preguntaComentario'}>
            {strings.footerMotives}
          </p>
        </div>
      )}
      {showErrors && get(errors, 'motive', []).length > 0 && (
        <div className={'error'}>* {t('errors.complete-motives')}</div>
      )}
    </div>
  );
};

export default Motives;
